import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "./AdminMenu";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import ReactPaginate from "react-paginate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import {ADMIN_API_BASE} from "../../utils/apiConfig";

const AdminUserPurchases = () => {

    const [filteredPurchases, setFilteredPurchases] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 20;
    const [purchases, setPurchases] = useState([]);

    const getCsrfToken = async () => {
        const res = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include",
        });
        const data = await res.json();
        return data.csrfToken;
    };

    useEffect(() => {
        const fetchPurchases = async () => {
            try {
                const token = await getCsrfToken();
                const response = await axios.get(`${ADMIN_API_BASE}/purchase`,
                    {
                        withCredentials: true,
                        headers: {
                            'csrf-token': token,
                        }
                    });
                console.log(response);
                if (response.data.success) {
                    setPurchases(response.data.purchases);
                    setFilteredPurchases(response.data.purchases);
                } else {
                    console.error('Failed to fetch purchases');
                }
            } catch (error) {
                console.error('There was a problem with the axios request:', error);
            }
        };

        fetchPurchases();
    }, []);

    useEffect(() => {
        let sortedPurchases = [...purchases];
        setFilteredPurchases(sortedPurchases);
        setCurrentPage(0); // Reset to first page on sort
    }, [purchases]);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const offset = currentPage * itemsPerPage;
    const currentPurchases = filteredPurchases.slice(offset, offset + itemsPerPage);

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title='خرید ها'/>
                        <div className='w-full grid grid-cols-6 gap-4 py-3 px-10 flex-1 my-10'>
                            {currentPurchases.map(item => (
                                <div
                                    key={item.id}
                                    className="bg-white w-full p-3 shadow-md rounded-md transition hover:bg-gray-100 hover:-translate-y-2">
                                    <h2 className="text-md line-clamp-2 mb-5">{item.user_id}</h2>
                                    <span className="text-sm block text-gray-700">{item.course_id}</span>
                                    <span className="text-sm block text-gray-400">{item.purchased_at}</span>
                                </div>
                            ))}
                        </div>
                        <ReactPaginate
                            previousLabel={'قبلی'}
                            nextLabel={'بعدی'}
                            breakLabel={'...'}
                            pageCount={Math.ceil(filteredPurchases.length / itemsPerPage)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination flex justify-center mt-4'}
                            activeClassName={'active'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link p-2 border rounded mx-1'}
                            previousClassName={'page-item'}
                            previousLinkClassName={'page-link p-2 border rounded mx-1'}
                            nextClassName={'page-item'}
                            nextLinkClassName={'page-link p-2 border rounded mx-1'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link p-2 border rounded mx-1'}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminUserPurchases;
